import { render, staticRenderFns } from "./IngredientItemStepCreate.vue?vue&type=template&id=02df7da5&"
import script from "./IngredientItemStepCreate.vue?vue&type=script&lang=js&"
export * from "./IngredientItemStepCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports